module.exports = __webpack_public_path__ + "img/logo.bb4d94ae.jpg";